export class Server {
    static _main;
    static get main() { return Server._main; }

    constructor(config) {
        Server._main = this;

        if (config === undefined) {
            config = {};
        }

        this._urls = {};
        this._setURLs(config.urls);

        this._sentRequest = false;
        this._debug = config.debug;
        this._simulation = config.simulation ?? false;
        this._simulationDelay = config.simulationDelay ?? 1;
        this._successfulDataStatus = config.successfulDataStatus ?? [0, 200, 201];
        this._onFailedToReceiveData = config.onFailedToReceiveData;
        this._onFailedToConnect = config.onFailedToConnect;
        this._lastPostKey = "";
    }

    get urls() {
        return this._urls;
    }

    get lastPostKey() {
        return this._lastPostKey;
    }

    //
    // Set URLs
    //
    _setURLs(urls) {
        if (urls === undefined || typeof urls !== "object") return;
        
        let keys = Object.keys(urls);

        if (keys.length == 0) return;

        for (let i = 0; i < keys.length; i++) {
            if (typeof urls[keys[i]].url !== "string" ||
                typeof urls[keys[i]].data !== "object") continue;
            if (!this._validateURL(urls[keys[i]].url)) continue;
            
            this._urls[keys[i]] = {
                url: urls[keys[i]].url,
                data: urls[keys[i]].data
            };
        }
    }
    _validateURL(url) {
        if (url === undefined || typeof url !== "string") return false;
        if (!url.includes("http://") && !url.includes("https://")) return false;
        return true;
    }

    //
    // Post Data
    //
    requestData(key,callback,errorCallback) {
        this._lastPostKey = key;

        if (this._urls[key] === undefined) return;

        this._postData(this._urls[key].url, this._urls[key].data, (data) => {
            if (callback === undefined) return;
            if (this._validateReceivedData(data)) callback(data);
            else if (errorCallback !== undefined) errorCallback(data);
            else this._onFailedToReceiveData?.(data);
        }, errorCallback);
    }
    requestBalanceUpdate(callback) {
        if (this._urls["balance"] === undefined) return;
        this._postData(this._urls["balance"].url, this._urls["balance"].data, (data) => {
            if (this._validateReceivedData(data)) callback?.(data);
            else this._onFailedToReceiveData?.(data);
        }, () => this._onFailedToReceiveData?.());
    }
    requestTermination() {
        if (this._urls["termination"] === undefined) return;
        this._postData(this._urls["termination"].url, this._urls["termination"].data, () => {});
    }

    async _postData(url = "",data = {},callback,onError) {
        if (this._simulation) {
            return this._simulateData(data, callback);
        }

        if (!navigator.onLine) {
            this._onFailedToConnect?.();
            return undefined;
        }

        this._sentRequest = true;
        let result = fetch(url, {
            method: "POST",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            redirect: "follow",
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then((data) => {
            this._sentRequest = false;
            callback(data);
        });

        if (!this._debug) result = result.catch(onError);

        return result;
    }

    async _simulateData(data = {},callback) {
        await this._delayResponse(this._simulationDelay * 1000);
        if (data.error == "offline") {
            this._onFailedToConnect?.();
            return undefined;
        }
        callback(data);
        return data;
    }
    _delayResponse(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    _validateReceivedData(data) {
        for (let i = 0; i < this._successfulDataStatus.length; i++) {
            if (data["status"] === this._successfulDataStatus[i]) return true;
        }
        return false;
    }
}